module.exports = __webpack_public_path__ + "static/media/scene_four.cf33eaee.png";